//-------------------------------api-url-for development------------------------------*/
// export const Baseurl = 'http://127.0.0.1:3001/';

//------------------------------------for-production-----------------------------------*/
export const Baseurl = 'https://api.bbmsoftware.com/';

//------------------------------------temp-----------------------------------*/
// export const Baseurl = 'http://192.168.43.90:3001/';
